import * as z from "zod";

/** Whether the team currently has an active coverage A/B test running. */
export const hasActiveCoverageSplit = {
  name: "hasActiveCoverageSplit" as const,
  input: z.null(),
  output: z.object({ hasActiveSplit: z.boolean() }),
};
